/* eslint-disable @typescript-eslint/no-unused-vars */
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/material";
import Box from "@mui/material/Box/Box";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Slide from "@mui/material/Slide";
import Typography from "@mui/material/Typography/Typography";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

import Keys from "../../constants/Keys";
import { layoutPrivateStyle } from "../../styles/layout/private-routes";
import { layoutPublicStyle } from "../../styles/layout/public-routes";
import { MobileMenuProps } from "../../types/mobile-menu";

export function SideMenuPublicRoute({
  mobileMenu,
  setMobileMenu,
}: MobileMenuProps) {
  const containerRef = useRef(null);
  const sideMenu = (
    <Paper elevation={4}>
      <Box sx={layoutPublicStyle.sideMenuPaperBox}>
        <Box sx={layoutPublicStyle.sideMenuBoxIcon}>
          <CloseIcon
            sx={layoutPublicStyle.sideMenuIcon}
            onClick={() => setMobileMenu?.(!mobileMenu)}
          />
        </Box>
        <Box sx={layoutPublicStyle.sideMenuBoxLink}>
          <Link
            href="/login"
            underline="none"
            sx={layoutPublicStyle.sideMenuLink}
          >
            <Typography sx={layoutPublicStyle.sideMenuLinkTypography}>
              Support
            </Typography>
          </Link>
        </Box>
      </Box>
    </Paper>
  );

  return (
    <Box ref={containerRef} sx={layoutPublicStyle.sideMenu}>
      <Slide direction="left" in={mobileMenu}>
        {sideMenu}
      </Slide>
    </Box>
  );
}

export function SideMenuPrivateRoute({
  mobileMenu,
  setMobileMenu,
}: MobileMenuProps) {
  const containerRef = useRef(null);

  const Navigate = useNavigate();

  const sideMenu = (
    <Paper elevation={4}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          width: "100%",
          padding: "16px",
          borderBottom: "1px solid rgba(0,0,0, 0.1)",
        }}
      >
        <Box
          component="img"
          src="/assets/icon/semesta.svg"
          onClick={() => setMobileMenu?.(!mobileMenu)}
          sx={layoutPrivateStyle.headerIcon}
        />
        <Typography
          sx={{
            fontSize: "14px",
            color: "#028ED5",
            cursor: "pointer",
            "&:hover": { textDecoration: "underline" },
            display: "none",
          }}
          onClick={() => Navigate("/")}
        >
          My Dashboard
        </Typography>
      </Stack>
      <Box sx={layoutPrivateStyle.appMenuPaperBox}>
        <Box sx={layoutPrivateStyle.appMenuBoxLink}>
          <Link
            key="Legal CRR"
            target="_blank"
            href="https://crr.apps.binus.edu/Login"
            sx={layoutPrivateStyle.appMenuLink}
          >
            <Box
              component="img"
              sx={layoutPrivateStyle.appMenuLinkBoxImg}
              alt="Legal CRR"
              src={`${Keys.Public_CDN}alesa-public-cdn/get-icon-logo-byurl?uri=https://publiccdn.sharepointonline.com/binusianorg.sharepoint.com/sites/ALESA-UAT/CDNASSETS/IconLogo/binus.jpg`}
            />
            <Typography sx={layoutPrivateStyle.appMenuLinkTypography}>
              Legal CRR
            </Typography>
          </Link>

          <Link
            key="Legal CLDR"
            target="_blank"
            href="https://legal.apps.binus.edu/"
            sx={layoutPrivateStyle.appMenuLink}
          >
            <Box
              component="img"
              sx={layoutPrivateStyle.appMenuLinkBoxImg}
              alt="Google"
              src={`${Keys.Public_CDN}alesa-public-cdn/get-icon-logo-byurl?uri=https://publiccdn.sharepointonline.com/binusianorg.sharepoint.com/sites/ALESA-UAT/CDNASSETS/IconLogo/binus.jpg`}
            />
            <Typography sx={layoutPrivateStyle.appMenuLinkTypography}>
              Legal CLDR
            </Typography>
          </Link>

          <Link
            key="Legal Document"
            target="_blank"
            href="https://legal.binus.edu/"
            sx={layoutPrivateStyle.appMenuLink}
          >
            <Box
              component="img"
              sx={layoutPrivateStyle.appMenuLinkBoxImg}
              alt="Google"
              src={`${Keys.Public_CDN}alesa-public-cdn/get-icon-logo-byurl?uri=https://publiccdn.sharepointonline.com/binusianorg.sharepoint.com/sites/ALESA-UAT/CDNASSETS/IconLogo/binus.jpg`}
            />
            <Typography sx={layoutPrivateStyle.appMenuLinkTypography}>
              Legal Document
            </Typography>
          </Link>
        </Box>
      </Box>
    </Paper>
  );

  return (
    <Box ref={containerRef} sx={layoutPrivateStyle.appMenu}>
      <Slide direction="right" in={mobileMenu} key="slideRight">
        {sideMenu}
      </Slide>
    </Box>
  );
}
